import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import "./assets/layout/flags/flags.css";
import "./assets/layout/layout.scss";
import "./App.css";

import "react-app-polyfill/ie11";
import { createRoot } from "react-dom/client";
import { HashRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { I18nextProvider } from "react-i18next";
import { i18n } from "./shared/language";
import { ChatBubbleLocaleSync } from "./shared/language/ChatBubbleLocaleSync";

import { AppToast } from "./AppToast";
import { AppConfirmDialog } from "./AppConfirmDialog";
import { AppInfoDialog } from "./AppInfoDialog";
import { AppLoading } from "./AppLoading";

import App from "./app";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgot-password";
import ConfirmSignStatement from "./pages/xac-nhan-ky-bien-ban";
import HDDT from "./app/hddt";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <I18nextProvider i18n={i18n}>
    <HashRouter>
      <ChatBubbleLocaleSync />
      <AppToast />
      <AppConfirmDialog />
      <AppInfoDialog />
      <AppLoading />
      <ScrollToTop>
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route
            path="confirm-sign-statement"
            element={<ConfirmSignStatement />}
          />
          <Route path="document/:id" element={<HDDT />} />
          <Route path="*" element={<App />} />
        </Routes>
      </ScrollToTop>
    </HashRouter>
  </I18nextProvider>
);

export * from "./shared/language";

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
